export default "__VITE_ASSET__CSi1Uc9G__"